/**
 * Lazy-loaded icons with encapsulated Suspense boundaries.
 */
import React, { Suspense } from 'react';

// oxlint-disable-next-line @atlassian/no-restricted-imports
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

import { withBrandIcon, type BrandIcon } from '../../../icons/with-brand-icon';

const OfficialIcon = lazyForPaint(
	() =>
		import(
			/* webpackChunkName: "@atlassian/logo-third-party/microsoft-power-bi" */ '@atlassian/logo-third-party/microsoft-power-bi'
		).then((m) => m.MicrosoftPowerBIIcon),
	{ moduleId: '@atlassian/logo-third-party/microsoft-power-bi' },
);

const LazyPowerBIIconComponent = lazyForPaint(
	() => import(/* webpackChunkName: "icon-powerBI" */ './utils').then((m) => m.PowerBIIcon),
	{ moduleId: '@atlassian/rovo-connectors-config/powerBI/icon' },
);

const LazyPowerBISearchResultIconComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-powerBI-search-result" */ './utils').then(
			(m) => m.PowerBISearchResultIcon,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/powerBI/search-result-icon' },
);

const LazyPowerBIIconBorderlessComponent = lazyForPaint(
	() =>
		import(/* webpackChunkName: "icon-powerBI-borderless" */ './utils').then(
			(m) => m.PowerBIIconBorderless,
		),
	{ moduleId: '@atlassian/rovo-connectors-config/powerBI/icon-borderless' },
);

/**
 * Exported icons with self-contained Suspense boundaries.
 * Consumers can use these directly without wrapping in LazySuspense.
 */
export const PowerBIIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyPowerBIIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'small',
);

export const PowerBISearchResultIcon: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyPowerBISearchResultIconComponent />
		</Suspense>
	),
	OfficialIcon,
	'medium',
);

export const PowerBIIconBorderless: BrandIcon = withBrandIcon(
	(): React.JSX.Element => (
		<Suspense fallback={null}>
			<LazyPowerBIIconBorderlessComponent />
		</Suspense>
	),
	OfficialIcon,
	'xxsmall',
);
